import { gql } from "@apollo/client";

const PUBLIC_SERVANT = gql`
    query PublicServant($publicServant: String, $timelineOffset: Int) {
        official(name: $publicServant) {
            givenName
            familyName
            title
            branch
            institution
        }
        totalTimeline(publicServant: $publicServant)
        totalRelationships(official: $publicServant)
        relationships(official: $publicServant) {
            _id
            clientName
            meetings
        }
        timelineChart(official: $publicServant) {
            year
            week
            month
            data {
                company
                meetings
            }
        }
        treeChart(official: $publicServant) {
            name
            meetingCount
            children {
                name
                meetingCount
            }
        }
        timeline(publicServant: $publicServant, offset: $timelineOffset, limit: 5) {
            _id
            date
            clientNameEn
            lobbyist
            consultancy
            officials {
                givenName
                familyName
                name
                title
                branch
                institution
            }
        }
        pageViews(name: $publicServant, entityType: "PUBLIC_SERVANT")
    }
`

export default PUBLIC_SERVANT;